export default __webpack_public_path__ + "static/Saly-13-bfa0bd4857438843bda0782a1e873470.png";